module.exports = __webpack_public_path__ + "static/img/titlebg.3875f0fc.png";